// @ts-strict-ignore
import React, { useState } from 'react';
import { Card } from '@usealloy/component-library';

import DiligenceData from '~/entities/evaluations/DiligenceData/DiligenceData';
import { useFetchedUserContext } from '~/helpers/hooks';
import type { FeatureFlags } from '~/helpers/typescript';

import { useEventTypeEvaluationsContext } from '../context';

const Diligence: React.FC = () => {
  const { evaluation, constructWatchlistMatchDataObject } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags = {} as FeatureFlags } = useFetchedUserContext();

  const isWorkflowTypeJourneyRouter = evaluation.evaluation_type === 'journey_router';
  const isWorkflowTypeReconciliation = evaluation.evaluation_type === 'reconciliation';

  const [matchInfo] = useState(constructWatchlistMatchDataObject(
    evaluation.final_response,
  ));

  const shouldShowDiligence = (
    evaluation.final_response
    && evaluation.final_response.diligence
    && !isWorkflowTypeJourneyRouter
    && !isWorkflowTypeReconciliation
  );

  if (!shouldShowDiligence) {
    return null;
  }

  return (
    <Card
      header="Diligence"
      collapsible
    >
      <DiligenceData
        containsWatchlistMatch={matchInfo.length > 0}
        hideFinancial={featureFlags?.['credit-panel']}
        response={evaluation.final_response}
        evaluationToken={evaluation.evaluation_token}
      />
    </Card>
  );
};

export default Diligence;
